module.exports = __webpack_public_path__ + "img/02-4排产效率.a5e937ab.svg";